/**
 * Replaces Klaviyo Back in Stock form copy with Shopify locale strings.
 * English "from" strings must match the Klaviyo form editor exactly.
 */
(function () {
  var config = window.klaviyoBisI18n;
  if (!config || !config.replacements || !config.replacements.length) {
    return;
  }

  var FORM_SELECTOR = '[data-testid^="klaviyo-form"], form.klaviyo-form';
  var TEXT_SELECTOR = 'h1, h2, h3, p, label, button, legend, span';
  var scheduledForms = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var scheduledFormIds = [];

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function isSafeToReplaceElementContent(element) {
    return !element.querySelector('input, button, select, textarea');
  }

  function formStillHasEnglish(form) {
    var text = form.textContent || '';

    return config.replacements.some(function (pair) {
      return pair.from && text.indexOf(pair.from) !== -1;
    });
  }

  function shouldTranslate(form) {
    if (formStillHasEnglish(form)) {
      return true;
    }

    if (config.emailPlaceholder && config.emailPlaceholderFrom) {
      var inputs = form.querySelectorAll('input[type="email"]');
      for (var i = 0; i < inputs.length; i++) {
        if (normalize(inputs[i].placeholder) === normalize(config.emailPlaceholderFrom)) {
          return true;
        }
      }
    }

    return false;
  }

  function replaceTextNodes(root, from, to) {
    if (!from || !to || from === to) {
      return;
    }

    var fromNorm = normalize(from);
    var toNorm = normalize(to);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      var textNode = walker.currentNode;
      var current = normalize(textNode.textContent);

      if (current === toNorm) {
        continue;
      }

      if (current === fromNorm) {
        textNode.textContent = to;
      }
    }
  }

  function replaceMatchingText(root) {
    config.replacements.forEach(function (pair) {
      if (!pair.from || !pair.to || pair.from === pair.to) {
        return;
      }

      var fromNorm = normalize(pair.from);
      var toNorm = normalize(pair.to);

      replaceTextNodes(root, pair.from, pair.to);

      root.querySelectorAll(TEXT_SELECTOR).forEach(function (element) {
        var current = normalize(element.textContent);

        if (current === toNorm || current !== fromNorm) {
          return;
        }

        if (!isSafeToReplaceElementContent(element)) {
          return;
        }

        element.textContent = pair.to;
      });
    });

    if (config.emailPlaceholder) {
      root.querySelectorAll('input[type="email"]').forEach(function (input) {
        if (
          !config.emailPlaceholderFrom ||
          normalize(input.placeholder) === normalize(config.emailPlaceholderFrom)
        ) {
          input.placeholder = config.emailPlaceholder;
        }
      });
    }

    if (config.emailLabel && config.emailLabelFrom) {
      var labelFromNorm = normalize(config.emailLabelFrom);
      root.querySelectorAll('label').forEach(function (label) {
        if (normalize(label.textContent) === labelFromNorm && isSafeToReplaceElementContent(label)) {
          label.textContent = config.emailLabel;
        }
      });
    }
  }

  function translateForm(form) {
    if (!form || !shouldTranslate(form)) {
      return;
    }

    replaceMatchingText(form);
  }

  function scheduleTranslateOnce(form) {
    if (!form.id && !form.getAttribute('data-testid')) {
      form.setAttribute('data-klaviyo-bis-form-id', String(Date.now()) + Math.random());
    }

    var formKey = form.id || form.getAttribute('data-testid') || form.getAttribute('data-klaviyo-bis-form-id');

    if (scheduledForms) {
      if (scheduledForms.has(form)) {
        return;
      }
      scheduledForms.add(form);
    } else if (scheduledFormIds.indexOf(formKey) !== -1) {
      return;
    } else {
      scheduledFormIds.push(formKey);
    }

    window.setTimeout(function () {
      translateForm(form);
    }, 400);
  }

  function findForm(node) {
    if (node.nodeType !== 1) {
      return null;
    }

    if (node.matches && node.matches(FORM_SELECTOR)) {
      return node;
    }

    return node.querySelector ? node.querySelector(FORM_SELECTOR) : null;
  }

  function handleForm(form) {
    translateForm(form);
    scheduleTranslateOnce(form);
  }

  function scan(node) {
    var form = findForm(node);

    if (!form) {
      return;
    }

    handleForm(form);
  }

  document.querySelectorAll(FORM_SELECTOR).forEach(handleForm);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        scan(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
